export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/arrow-right.e41abe7c-8afd0f.svg";